module.exports = __webpack_public_path__ + "img/location_marker1.38978911.png";